const ArtworkSvg: React.FC<{ color?: string }> = ({ color }) => {
  return (
    <svg
      width="33"
      height="34"
      viewBox="0 0 33 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5841 11.468C15.9631 10.773 16.9609 10.773 17.3399 11.468L18.4875 13.5722C18.6313 13.8359 18.8861 14.021 19.1814 14.0763L21.5372 14.5175C22.3153 14.6632 22.6236 15.6122 22.0798 16.1874L20.4332 17.9291C20.2268 18.1474 20.1295 18.4469 20.1682 18.7448L20.4766 21.1217C20.5785 21.9066 19.7712 22.4932 19.0561 22.1537L16.8908 21.1259C16.6195 20.9971 16.3045 20.9971 16.0332 21.1259L13.8679 22.1537C13.1528 22.4932 12.3455 21.9066 12.4474 21.1217L12.7558 18.7448C12.7945 18.4469 12.6972 18.1474 12.4908 17.9291L10.8442 16.1874C10.3004 15.6122 10.6087 14.6632 11.3868 14.5175L13.7426 14.0763C14.0379 14.021 14.2927 13.8359 14.4365 13.5722L15.5841 11.468Z"
        fill={color || "white"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.49293 2.9886L6.49293 7.01017H2.50974V8.01017H6.49293L6.49293 26.0104H2.50974V27.0104H6.49293L6.49293 30.5832H7.49293V27.0104H25.4992V30.9986H26.4992V27.0104H30.5062V26.0104H26.4992L26.4992 8.01017H30.5062V7.01017H26.4992V2.9886H25.4992V7.01017H7.49293V2.9886H6.49293ZM25.4992 26.0104L25.4992 8.01017H7.49293L7.49293 26.0104H25.4992Z"
        fill={color || "white"}
      />
      {/* <rect
        x="0.337006"
        y="0.964645"
        width="32.25"
        height="32.25"
        stroke="#8B8B8B"
        stroke-width="0.25"
      /> */}
    </svg>
  );
};

export default ArtworkSvg;
